export const Types = [
    {
        "ID": 1,
        "value": "From field"
    },
    {
        "ID": 2,
        "value": "Dry from shed"
    }
];